var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"trace-progress"},[_c('div',{ref:"outer",staticClass:"trace-progress-inner"},[_c('div',{ref:"inner",staticClass:"range"})]),_c('div',{staticClass:"trace-progress-text"},[_vm._v(_vm._s(_vm.percent)+"%")])])}
var staticRenderFns = []

export { render, staticRenderFns }